import logo from 'assets/images/logo.svg';

export const NavLogo = {
  template: `
    <div class="nav-logo">
      ${logo}
      <span class="sr-only">Voome</span>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Nav/NavLogo.js